module.exports = __webpack_public_path__ + "ga-logo-79b0d889922988a462cd536052f70f6c.png";